import BatchDetailsReportIndex from "@/Reports/BatchDetailsReportIndex.vue";
import PaymentsReportIndex from "@/Reports/PaymentsReportIndex.vue";
import UnbatchedReportIndex from "@/Reports/UnbatchedReportIndex.vue";
import TokenExportsIndexContainer from "@/TokenExports/TokenExportsIndexContainer.vue";

export default [
  {
    path: "/transactions",
    name: "PaymentsReportIndex",
    component: PaymentsReportIndex,
    meta: {
      permissionRoles: ["financial_data"]
    }
  },
  {
    path: "/accounting/unbatched",
    name: "UnbatchedReportIndex",
    component: UnbatchedReportIndex,
    meta: {
      permissionRoles: ["financial_data"]
    }
  },
  {
    path: "/token_exports",
    name: "TokenExportsIndexContainer",
    component: TokenExportsIndexContainer,
    meta: {
      permissionRoles: ["export_payment_tokens"]
    }
  }
];
